<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="fill-height" @click="dialog = true">
        <custom-popup
          v-model="dialog"
          :cons="{ title: $t('userpicker.info_edit') }"
          max-width="600"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-edit-information`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('userpicker.info_edit')"
            />
          </template>
          <v-card flat>
            <v-card-text>
              <div class="rowinfo">
                <v-text-field
                  v-model="computedValue.full_name"
                  clear-icon="mdi-close-circle-outline"
                  class="contentinfo"
                  clearable
                  dense
                  :label="$t('userpicker.name_family')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-full_name`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('userpicker.name_family')"
                />
              </div>
              <div class="rowinfo">
                <v-text-field
                  v-model="computedValue.position"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  class="contentinfo"
                  dense
                  :label="$t('userpicker.position')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-position`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('userpicker.position')"
                />
              </div>
              <div class="rowinfo">
                <v-text-field
                  v-model="computedValue.phone"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  class="contentinfo"
                  dense
                  hide-details
                  :label="$t('userpicker.phone')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-phone`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('userpicker.phone')"
                />
              </div>

              <pic-selector
                v-model="computedValue.image"
                :edit-name="false"
                one-pic
                single
              />
              <div class="rowinfo">
                <v-textarea
                  v-model="computedValue.description"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  class="contentinfo"
                  dense
                  :label="$t('discription')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-computedValue-description`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('discription')"
                />
              </div>
            </v-card-text>
          </v-card>
        </custom-popup>

        <v-card class="rounded-lg overflow-hidden" flat height="100%" link>
          <v-list-item class="px-2" three-line>
            <v-list-item-content class="py-2">
              <div class="text-overline mb-4">
                <p class="m-0 p-0" style="font-size: 10pt">
                  {{ computedValue.position }}
                </p>
                <p class="p-0 m-0 mt-n2 font-weight-bold" dir="ltr">
                  {{ computedValue.phone }}
                </p>
              </div>

              <v-list-item-title class="mb-1">
                <h5 class="font-weight-bold text-wrap text-break">
                  {{ computedValue.full_name }}
                </h5>
              </v-list-item-title>
              <v-list-item-subtitle class="clamp">{{
                computedValue.description
              }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-avatar class="my-auto" size="80">
              <v-img v-if="getImage" :src="getImage" />
              <v-icon v-else x-large>mdi-account</v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </v-card>
      </div>
    </template>
  </help-info-wrapper>
</template>

<script>
import PicSelectorSingle from "@/view/components/UploadCenter/picSelectorSingle";
import PicSelector from "@/view/components/UploadCenter/picSelector";

export default {
  name: "CreatePersonnel",

  components: { PicSelector, PicSelectorSingle },

  props: {
    value: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "create-personnel",
      dialog: false,
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    getImage() {
      return !!this.computedValue.image[0].images &&
        this.computedValue.image[0].images.length
        ? this.computedValue.image[0].images[0].url
        : false;
    },
  },
};
</script>

<style scoped>
* {
  letter-spacing: 0 !important;
}

.clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
